import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'
import type { AgentState } from '@anvil/common/types/session-state'

export const handleSetMessages = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<'set_messages'>

  agentState: AgentState
}): Promise<{ output: AnvilToolOutput<'set_messages'> }> => {
  const { previousToolCallFinished, toolCall, agentState } = params

  await previousToolCallFinished
  agentState.messageHistory = toolCall.input.messages
  return { output: [{ type: 'json', value: { message: 'Messages set.' } }] }
}) satisfies AnvilToolHandlerFunction<'set_messages'>
